class ProductThumbs extends HTMLElement {
  constructor() {super()}
  connectedCallback() {
    this.thumbs = this.querySelectorAll(".product-media--thumb"), this.wrapper = this.querySelector(".product-media--thumbs-wrapper"), this.updateMediaListener(), this.clickListener()
  }
  disconnectedCallback() {window.off(`theme:product:${this.dataset.id}:variantChanged.ProductThumbs`)}
  updateMediaListener() {
    window.on(`theme:product:${this.dataset.id}:variantChanged.ProductThumbs`, ({detail: {variant: t}}) => {
      t.featured_media && this.updateActive(t.featured_media.id)
    })
  }
  clickListener() {
    this.thumbs.on("keypress click", ({target: t}) => {
      var e = parseInt(t.dataset.id);
      this.updateActive(e), window.trigger(`theme:product:${this.dataset.id}:mediaChanged`, {id: e})
    })
  }
  updateActive(i) {
    this.thumbs.forEach(t => {
      var e = parseInt(t.dataset.id);
      t.setAttribute("data-active", e === i), e === i && this.scrollIntoView(t)
    })
  }
  scrollIntoView(t) {
    var e = this.getBoundingClientRect(),
        i = t.getBoundingClientRect(),
        s = i.top - e.top;
    let r;
    r = s < e.height / 2 ? this.wrapper.scrollTop + s - (e.height - i.height) / 2 : this.wrapper.scrollTop + s - e.height / 2 + i.height / 2, this.wrapper.scrollTo({
        top: r,
        behavior: "smooth"
    })
  }
}
const productThumbsEl = customElements.get("product-thumbs-root");
productThumbsEl || customElements.define("product-thumbs-root", ProductThumbs);